import { Placement } from '@amzn/fire-tv-campaign-automation-service';
import { KatDropdown } from '@amzn/katal-react';
import { StyledDropdown } from 'src/components/general/StyledDropdown';
import { CMSConfig } from 'src/configs/campaignMetadataConfig';
import { useSelection } from 'src/contexts/SelectionContext';
import { PropUtils } from 'src/utils/PropUtils';

interface PlacementSelectorProps {}

const PlacementSelector = ({}: PlacementSelectorProps) => {
  const { placement, setPlacement } = useSelection();
  const handlePlacementChange = (event: KatDropdown.ChangeEvent) => {
    setPlacement(event.detail.value as Placement);
  };
  const placementOptions = PropUtils.getTitleCasedOptions(
    PropUtils.getOptionsWithUnderscoresRemoved(
      PropUtils.createOptionsFromEnumValues(CMSConfig.PLACEMENTS, Placement),
    ),
  );

  return (
    <StyledDropdown
      onChange={handlePlacementChange}
      options={placementOptions}
      label="Select Placement"
      style={{ marginRight: '25px' }}
      value={placement || Placement.FEATURE_ROTATOR}
    />
  );
};

export { PlacementSelector };
